module.exports = __webpack_public_path__ + "img/auction-5.9c1c22fa.png";